export default {
  namespaced: true,
  state: {
    data: [],
    pagination: {
      current: null,
      total: null,
      data: [],
    },
    tmp: {
      id: null,
      old: null,
      editing: false,
    },
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.data = data;
    },
    SET_PAGINATION: (state, data) => {
      state.pagination = data;
    },
    CANCEL_EDITING: (state) => {
      state.tmp = {
        id: null,
        editing: false,
        old: null,
      };
    },
  },
  actions: {
    all: function ({ commit, dispatch, state }, payload) {
      let url = "occupations";
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
      }
      if (!payload || !payload.page) {
        commit("SET_LOADING_STATE", true, { root: true });
      }
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_PAGINATION", {
                  total: res.data.total,
                  current: res.data.current_page,
                  data: [...state.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_PAGINATION", {
                  total: res.data.total,
                  current: res.data.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_DATA", res.data);
              }
              commit("SET_LOADING_STATE", false, { root: true });
              return resolve();
            }
            return resolve();
          })
          .catch((err) => {
            commit("SET_LOADING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    update: function ({ commit, dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        if (!(payload.name || "").trim()) {
          dispatch(
            "setError",
            {
              message: "Occupation name can't be empty",
              title: "Validation Error",
            },
            { root: true }
          );
          return resolve();
        }
        vm.$http
          .put(`occupations/${payload.id}`, { name: payload.name })
          .then((res) => {
            if (res.status == 200) {
              commit("CANCEL_EDITING");
              commit("SET_SAVING_STATE", false, { root: true });
            }
            return resolve();
          })
          .catch((err) => {
            commit("SET_SAVING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    create: function ({ commit, dispatch, state }, payload) {
      let vm = this;
      return new Promise((resolve) => {
        vm.$http
          .post(`occupations`, { name: payload.name })
          .then((res) => {
            commit("SET_SAVING_STATE", false, { root: true });
            if (res.status == 200 || res.status == 201) {
              dispatch(
                "setSuccess",
                {
                  message: "Vendor Successfully Deleted",
                  title: "Success",
                },
                { root: true }
              );

              state.pagination.data.push(res.data);
              state.pagination.total += 1;

              return resolve(true);
            }
            dispatch(
              "setError",
              {
                message:
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            return resolve(false);
          })
          .catch(() => {
            dispatch(
              "setError",
              {
                message:
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
            commit("SET_SAVING_STATE", false, { root: true });
            return resolve(false);
          });
      });
    },
  },
};
